import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { contactsAPI } from '@/lib/api';

// Pick a client (a contact). Shows the company first, the person after it.
export const contactLabel = (c) => c?.company || c?.full_name || c?.name || '';

export default function ContactSelect({ value, label, onChange, placeholder = 'Client (optional)', className = '' }) {
  const [q, setQ] = useState('');
  const [hits, setHits] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open || !q.trim()) { setHits([]); return undefined; }
    const t = setTimeout(() => contactsAPI.list({ search: q.trim() }).then((r) => setHits((r.data || []).slice(0, 12))).catch(() => {}), 200);
    return () => clearTimeout(t);
  }, [q, open]);

  if (value) {
    return (
      <div className={`h-10 flex items-center gap-2 rounded-md border border-input px-2 text-sm bg-white ${className}`}>
        <span className="truncate flex-1">{label || 'Client'}</span>
        <button type="button" className="text-[#94A3B8] hover:text-[#A62B1F]" onClick={() => onChange(null)} title="Clear"><X className="w-3.5 h-3.5" /></button>
      </div>
    );
  }
  return (
    <div className={`relative ${className}`}>
      <Input value={q} placeholder={placeholder} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        onChange={(e) => { setQ(e.target.value); setOpen(true); }} />
      {open && hits.length > 0 && (
        <div className="absolute z-50 left-0 right-0 mt-1 rounded-lg border border-[#E3DDD1] bg-white shadow-lg max-h-56 overflow-y-auto">
          {hits.map((c) => (
            <button key={c._id} type="button" className="w-full text-left px-3 py-1.5 hover:bg-[#FBF8F2]"
              onMouseDown={() => { onChange({ id: c._id, label: contactLabel(c) }); setQ(''); setOpen(false); }}>
              <div className="text-sm text-[#1E2A33]">{contactLabel(c)}</div>
              {c.company && c.full_name && <div className="text-[11px] text-[#5C6670]">{c.full_name}</div>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
